import { render } from "./PolicyPage.vue?vue&type=template&id=93ed621a&ts=true"
import script from "./PolicyPage.vue?vue&type=script&lang=ts"
export * from "./PolicyPage.vue?vue&type=script&lang=ts"

import "./PolicyPage.vue?vue&type=style&index=0&id=93ed621a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__